import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { BaseCollection } from "../../collections/_BaseCollection";
import { ModuleCollection } from "../../collections/Modules";
import { BaseList, BaseListOptions, ColumnProperties } from "../_BaseList";
import { MaxValuesModal, MaxValuesOptions } from "../modals/MaxValuesModal";

export interface InstallListOptions extends BaseListOptions {
    moduleCollections: { [key: number]: ModuleCollection };
    orgId: number;
}

export interface InstallTableProperties {
    name?: string;
    columnProperties: { [columnName: string]: ColumnProperties };
    canDeletePermissionFunction?: any;
    canDeletePermissionFunctionAttribute?: string;
    canEditPermissions?: boolean;
    dataPermissionType?: string;
    rowUrl?: string;
    rowUrlAttribute?: string;
    limitedRows?: {
        count: number;
        collectionProperties: any;
        sortBy: string;
        reverseSort: boolean;
    };
    installSubMenu?: boolean;
    installSummary?: boolean;
    canModify?: boolean;
    tableEmptyText?: string;
    tableWidth?: string;
    footer?: {
        url: string;
        text: string;
    };
}

export class InstallList extends BaseList {
    options: InstallListOptions;

    private installCollectionListTemplate = _.template(require("templates/account/install/installListCollection.html"));

    constructor(options: InstallListOptions) {
        super(
            <any>_.extend(options, {
                events: {
                    "click .set-organization-maxes": "setOrgMaxes",
                },
            })
        );
    }

    renderCollectionList(collection: BaseCollection<Backbone.Model>, properties: InstallTableProperties) {
        this.$el.html(
            this.installCollectionListTemplate({
                collection: collection,
                currentOrganization: this.options.organizationCollection.findWhere({ id: this.options.orgId }),
                moduleCollections: this.options.moduleCollections ? this.options.moduleCollections : null,
                properties: _.extend({}, this.defaultProperties, properties),
                canSetMaxValues: this.options.currentUser.isSensewareAdmin(),
            })
        );
        return this;
    }

    setOrgMaxes() {
        var orgId = this.options.orgId;
        var organization = this.options.organizationCollection.findWhere({ id: this.options.orgId });
        var name = _.escape(organization.get("name"));

        var modal = new MaxValuesModal({
            titleText: "Update Organization " + name,
            text: "For this organization, Attune allows the following maximums:",
            name: name,
            record: organization,
            buttonText: "Update",
            func: (installOptions: MaxValuesOptions) => {
                return $.ajax({
                    type: "PUT",
                    url: this.options.organizationCollection.url() + "/" + orgId + "/updateMaxValues/",
                    data: JSON.stringify(installOptions),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    complete: (res) => {
                        // Update our install values in the UI
                        $.when(this.options.organizationCollection.getCollectionFetchPromise()).done(() => {
                            this.reloadUrl();
                        });
                    },
                });
            },
        });
        $(".modals").append(modal.render().el);
        modal.show();
    }

    render() {
        return this;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/InstallList.ts